<template>
    <div class="c-phone-number">
        <el-form
            :model="phoneNumberForm"
            :rules="validationRules"
            ref="phoneNumberForm"
            class="pd-form"
        >
            <el-form-item prop="phone" class="mb-0">
                <v-phone-input
                    ref="localPhone"
                    v-model="localPhone.phone"
                    default-country-code="AU"
                    :disabled="readonly"
                    @phone-number-blur="onPhoneBlur"
                    @update="updatePhone"
                />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { isValidPhoneNumber } from 'libphonenumber-js'

export default {
    name: 'PhoneNumber',
    props: {
        value: {
            type: Object,
            required: true,
            default: () =>  {
                return {
                    countryCode: '',
                    phone: '',
                    archived: false
                }
            }
        },
        required: {
            type: Boolean,
            default: true
        },
        validPhone: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            firstLoad: true,
            phone: '',
            isValid: false,
            defaultCountryCode: 'AU',
            phoneNumberForm: {
                countryCode: '',
                phone: '',
                archived: false
            },
            validationRules: {
                phone: [{ validator: this.validateInput, trigger: 'blur' }]
            }
        }
    },
    methods: {
        validate() {
            // validate returns a promise if we don't provide a callback
            return this.$refs.phoneNumberForm.validate()
        },
        isValidNumber() {
            if (!this.localPhone.phone) return false
            // Same library v-phone-input validates with, so a saved number is
            // judged the same way as one just typed. It accepts numbers stored
            // without the trunk zero, e.g. 411111111 and 895541340.
            return isValidPhoneNumber(
                this.localPhone.phone,
                this.localPhone.countryCode || this.defaultCountryCode
            )
        },
        validateInput(rule, value, cb) {
            // v-phone-input only emits @update for a value present at mount or
            // parseable as international, so a number loaded from the backend
            // often leaves isValid false. Check it ourselves in that case.
            if (!this.isValid) {
                this.isValid = this.isValidNumber()
            }

            // first we check if we are adding or editing
            if (this.required) {
                if (!this.localPhone.phone) {
                    cb('This field is required')
                } else if (this.isValid !== undefined && this.isValid !== true) {
                    // if isValid is undefined, then the value would be from the backend and we don't need to do anything
                    cb('Invalid phone number format')
                } else {
                    cb()
                }
            } else if(this.validPhone) {
                if (this.isValid !== undefined && this.isValid !== true && this.localPhone.phone !==  '') {
                    // if isValid is undefined, then the value would be from the backend and we don't need to do anything
                    cb('Invalid phone number format')
                } else {
                    cb()
                }
            } else {
                cb()
            }
        },
        onPhoneBlur() {
            if (this.isValid) {
                this.$refs.phoneNumberForm.resetFields()
            } else {
                this.$refs.phoneNumberForm.validate()
            }
            this.$emit('blur', this.value)
        },
        updatePhone(e) {
            this.isValid = e.isValid
        }
    },
    computed: {
        localPhone: {
            get() {
                return this.value
            },
            set(localPhone) {
                this.$refs.phoneNumberForm.phone = localPhone.phone
                this.phoneNumberForm.phone = localPhone.phone
                this.$emit('input', localPhone)
            }
        },
    },
}
</script>
